import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { useState } from "react";
import { useGlobalState } from "../../../context/AppContext";

interface Props {
  children?: React.ReactElement<unknown>
}

export default function NoticeDaialog(props: Props) {
  /** グローバルステート */
  const { state, setState } = useGlobalState()
  /** Submitボタン活性判定 */
  const [isDisabled, setIsDisabled] = useState(false)
  /** 閉じる処理 */
  const handleClose = () => {
    // submit処理中は閉じない
    if (!isDisabled) {
      setState({
        ...state,
        dialog: {
          ...state.dialog,
          isOpen: false
        }
      })
    }
  }
  /** 確定処理 */
  const handleSubmit = async () => {
    setIsDisabled(true)
    await state.dialog.submitProcess()
    setIsDisabled(false)
  }
  return (
    <React.Fragment>
      <Dialog
        open={state.dialog.isOpen}
        onClose={handleClose}
        fullWidth
      >
        <DialogTitle>
          {state.dialog.title}
        </DialogTitle>
        <DialogContent>
          {state.dialog.content}
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={isDisabled}
            onClick={handleClose}
          >
            {state.dialog.cancelLabel}
          </Button>
          <Button
            type="button"
            color="primary"
            variant="contained"
            disabled={isDisabled}
            onClick={handleSubmit}
            autoFocus
            endIcon={isDisabled && <CircularProgress color="secondary" size="1rem" />}
          >
            {state.dialog.submitLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}